import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClient } from "src/app/definitions/api/api-client";

import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class ApiAccessService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/api/clients", appConfigService.getConfigValue("API_ENDPOINT"));
	}

    getClient(clientId: string): Observable<ApiClient> {
        return this.api.get(this.url(`/${clientId}`), "errors.get-client-secret-failed");
    }

    createClient(allowedAuthScopes: string[]): Observable<ApiClient> {
        return this.api.post(this.url(), { allowedAuthScopes }, "errors.create-api-client-failed");
    }

    removeClient(clientId: string): Observable<void> {
        return this.api.delete(this.url(`/${clientId}`), "errors.remove-api-client-failed");
    }
}